import React, { useState, useEffect } from "react";
import ReactStrapTable from "components/reactStrapTable";
import { cellRendererCheck, currencyFormat, dateFormate } from "utils/columns";
import { cloneDeep } from "lodash";
import useAxios from "hooks/useAxios";
import { faL } from "@fortawesome/free-solid-svg-icons";

const SbDetailsTable = (props) => {
    const { reportType, detailsData, orgId, totalItem,FullRowData, search,collapseSider,toggleSider, onSearchColumnFilters,resetFilterFlag,
        SetResetFilterFlag = () => '', refetch, onPageChange, filters,pharmaOrders,key
} = props;

    const [state, updateState] = useState({
        tableData: [],
        backUpData: [],
        filters: filters,
    });
    const API = useAxios();
      const [columnFilters, setColumnFilters] = useState([]);
    useEffect(() => {
        setState({ tableData: detailsData, backUpData: detailsData });
    }, [detailsData]);
    const setState = (obj) => updateState(pre => ({ ...pre, ...obj }));

    useEffect(() => {
        setState({ filters: filters });
    }, [filters]);

    const dateFormateTime = (value) => {
    if (!value) return '-';
    const date = new Date(value);
    const options = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    };
    const data1 = date !== null ? date?.toLocaleString('en-US', options).replace(",", "").replace(/\//g, "/") : "-"
    return data1;
  };


    let utilizationcoloums = [
        {
            dataField: 'options',
            text: 'Options',
            sort: false,
            width: 100,
            show: true,
            hidecolFilter: true,
            action: true
        },
        {
            dataField: 'ceName',
            text: 'Covered Entity',
            sort: true,
            width: 240,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.ceName),
            showColumn: true
        },
        {
            dataField: 'accumulatorName',
            text: 'Accumulator',
            sort: true,
            width: 240,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.accumulatorName),
            showColumn: true
        },
        {
            dataField: 'accountType',
            text: 'Account Type',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.accountType === null ? 'Pending' : rowData.accountType),
            showColumn: true,
            screenName: 'UtilizationReport',
            pendingAccountTypeId:'1004'
        },
        {
            dataField: 'claimReason',
            text: 'Reason',
            sort: true,
            width: 200,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.claimReason),
            showColumn: true
        },
        {
            dataField: 'providerNPI',
            text: 'Provider NPI',
            sort: true,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.providerNPI ? rowData.providerNPI : '-'),
            showColumn: true
        },
        {
            dataField: 'providerName',
            text: 'Provider Name',
            sort: true,
            width: 200,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.providerName ? rowData.providerName : '-'),
            showColumn: true
        },
        {
            dataField: 'drugAdminDate',
            text: 'Date of Drug Administration',
            sort: true,
            width: 200,
            show: true,
            inputType: 'date',
            hideColFilter: false,
            cellRenderer: (row) => dateFormateTime(row.drugAdminDate),
            showColumn: true
        },
         {
            dataField: 'physicianOrderedDate',
            text: 'Physician Ordered Date',
            sort: true,
            width: 200,
            show: true,
            inputType: 'date',
            hideColFilter: false,
            cellRenderer: (row) => dateFormateTime(row.physicianOrderedDate),
            showColumn: true
        },
        {
            dataField: 'mrNumber',
            text: 'MR Number',
            sort: true,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.mrNumber),
            showColumn: true
        },
        {
            dataField: 'visitNumber',
            text: 'Visit Number',
            sort: true,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.visitNumber),
            showColumn: true
        },
           {
            dataField: 'claimID',
            text: 'Claim ID',
            sort: true,
            width: 140,
            show: true,
            inputType: 'number',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.claimID),
            showColumn: true
        },
          {
            dataField: 'drugUtilizationID',
            text: 'DrugUtilizationID',
            sort: true,
            width: 200,
            show: true,
            inputType: 'number',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.drugUtilizationID),
            showColumn: true
        },

        {
            dataField: 'patientType',
            text: 'Patient Type',
            sort: true,
            width: 240,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.patientType),
            showColumn: true
        },

        {
            dataField: 'serviceLocationDesc',
            text: 'Service Location',
            sort: true,
            width: 240,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.serviceLocationDesc),
            showColumn: true
        },
        {
            dataField: 'chargeCode',
            text: 'Charge Code',
            sort: true,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.chargeCode),
            showColumn: true
        },
        {
            dataField: 'chargeDescription',
            text: 'Charge Description',
            sort: true,
            width: 280,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.chargeDescription),
            showColumn: true
        },
        {
            dataField: 'ndc',
            text: 'NDC',
            sort: true,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.ndc ? rowData.ndc : '-'),
            showColumn: true
        },
        {
            dataField: 'drugName',
            text: 'NDC Description',
            sort: true,
            width: 280,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.drugName),
            showColumn: true
        },

        {
            dataField: 'grossCharge',
            text: 'Gross Charge',
            sort: true,
            width: 140,
            show: true,
            inputType: 'number',
            hideColFilter: false,
            cellRenderer: (rowData, col) => currencyFormat(rowData.grossCharge),
            showColumn: true
        },
        {
            dataField: 'dispensedQuantity',
            text: 'Quantity',
            sort: true,
            width: 140,
            show: true,
            inputType: 'number',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.dispensedQuantity),
            showColumn: true
        },
        {
            dataField: 'bupp',
            text: 'BUPP',
            sort: true,
            width: 140,
            show: true,
            inputType: 'number',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.bupp ? rowData.bupp : '-'),
            showColumn: true
        },
        {
            dataField: 'quantity',
            text: 'Accumulation',
            sort: true,
            width: 150,
            show: true,
            inputType: 'number',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.quantity),
            showColumn: true
        },
          {
            dataField: 'unitOfMeasure',
            text: 'UOM',
            sort: true,
            width: 150,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.unitOfMeasure),
            showColumn: true
        },
        {
            dataField: 'primaryPayor',
            text: 'Primary Payor',
            sort: true,
            width: 260,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.primaryPayor),
            showColumn: true
        },

        {
            dataField: 'secondaryPayor',
            text: 'Secondary Payor',
            sort: true,
            width: 260,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.secondaryPayor),
            showColumn: true
        },

        {
            dataField: 'tertiaryPayor',
            text: 'Tertiary Payor',
            sort: true,
            width: 240 ,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.tertiaryPayor),
            showColumn: true
        },
        {
            dataField: 'drugExclusionReason',
            text: 'Drug Exclusion Type',
            sort: true,
            width: 190,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.drugExclusionReason ? rowData.drugExclusionReason : '-'),
            showColumn: true
        },
        {
            dataField: 'orphanDrugFlag',
            text: 'Orphan Drug',
            sort: true,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.orphanDrugFlag),
            showColumn: true
        },
        {
            dataField: 'admitDate',
            text: 'Admit Date',
            sort: true,
            width: 160,
            show: true,
            inputType: 'date',
            hideColFilter: false,
            cellRenderer: (rowData, col) => dateFormate(rowData.admitDate),
            showColumn: true
        },
        {
            dataField: 'dischargeDate',
            text: 'Discharge Date',
            sort: true,
            width: 160,
            show: true,
            inputType: 'date',
            hideColFilter: false,
            cellRenderer: (rowData, col) => dateFormate(rowData.dischargeDate),
            showColumn: true
        },
        {
            dataField: 'facility',
            text: 'Facility',
            sort: true,
            width: 240,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.facility),
            showColumn: true
        },
        {
            dataField: 'hcpcsjcode',
            text: 'HCPCS',
            sort: true,
            width: 140,
            show: true,
            inputType: 'number',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.hcpcsjcode),
            showColumn: true
        },
        {
            dataField: 'transactionID',
            text: 'Transaction ID',
            sort: true,
            width: 150,
            show: true,
            inputType: 'number',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.transactionID),
            showColumn: true
        },
        {
            dataField: 'usedHL7',
            text: 'ADT Used',
            sort: true,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.usedHL7),
            showColumn: true
        },
        {
            dataField: 'hL7PatientType',
            text: 'HL7 Patient Type',
            sort: true,
            width: 220,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.hL7PatientType),
            showColumn: true
        },
        {
            dataField: 'hL7Location',
            text: 'HL7 Location',
            sort: true,
            width: 220,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.hL7Location),
            showColumn: true
        },
        {
            dataField: 'hL7PrimaryPayorDesc',
            text: 'HL7 PrimaryPayorDesc',
            sort: true,
            width: 220,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.hL7PrimaryPayorDesc),
            showColumn: true
        },
         {
            dataField: 'hL7SecondaryPayorDesc',
            text: 'HL7 SecondaryPayorDesc',
            sort: true,
            width: 220,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.hL7SecondaryPayorDesc),
            showColumn: true
        },
         {
            dataField: 'hL7TertiaryPayorDesc',
            text: 'HL7TertiaryPayorDesc',
            sort: true,
            width: 220,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.hL7TertiaryPayorDesc),
            showColumn: true
        },
        {
            dataField: 'fileProcessName',
            text: 'File Name',
            sort: true,
            width: 220,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.fileProcessName),
            showColumn: true
        }
    ]
    let drugspentcoloums = [
        {
            dataField: 'options',
            text: 'Options',
            sort: false,
            width: 100,
            show: true,
            hidecolFilter: true,
            action: true
        },
        {
            dataField: 'accounType',
            text: 'Account Type',
            sort: false,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.accounType),
            showColumn: true
        },
        {
            dataField: 'wholesalerName',
            text: 'Wholesaler Name',
            sort: false,
            width: 260,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.wholesalerName),
            showColumn: true
        },
        {
            dataField: 'poid',
            text: 'PO #',
            sort: true,
            width: 120,
            show: true,
            inputType: 'number',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.poid),
            showColumn: true
        },
        {
            dataField: 'filePOItemNumber',
            text: 'Source PO #',
            sort: true,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.filePOItemNumber),
            showColumn: true
        },
        {
            dataField: 'potype',
            text: 'PO Type',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.potype),
            showColumn: true
        },
        {
            dataField: "poItemStatus",
            text: "Item Status",
            sort: false,
            width: 100,
            show: true,
            inputType: "text",
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.poItemStatus),
            showColumn: true,
        },
        {
            dataField: 'purchaseDate',
            text: 'Purchase Date',
            sort: false,
            width: 140,
            show: true,
            inputType: 'date',
            hideColFilter: false,
            cellRenderer: (rowData, col) => dateFormate(rowData.purchaseDate),
            showColumn: true
        },
        {
            dataField: 'accountCode',
            text: 'Acct #',
            sort: false,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.accountCode),
            showColumn: true
        },
        {
            dataField: 'poItemID',
            text: 'PO Item #',
            sort: true,
            width: 120,
            show: true,
            inputType: 'number',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.poItemID),
            showColumn: true
        },
        {
            dataField: 'ndc',
            text: 'NDC',
            sort: true,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.ndc),
            showColumn: true
        },
        {
            dataField: 'drugName',
            text: 'Drug Name',
            sort: true,
            width: 260,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.drugName),
            showColumn: true
        },
        {
            dataField: 'itemInvoiceNumber',
            text: 'Invoice #',
            sort: true,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.itemInvoiceNumber),
            showColumn: true
        },
        {
            dataField: 'itemInvoicedDate',
            text: 'Invoiced Date',
            sort: true,
            width: 140,
            show: true,
            inputType: 'date',
            hideColFilter: false,
            cellRenderer: (rowData, col) => dateFormate(rowData.itemInvoicedDate),
            showColumn: true
        },
        {
            dataField: 'packageInvoiced',
            text: 'Packages',
            sort: true,
            width: 120,
            show: true,
            inputType: 'number',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.packages),
            showColumn: true
        },
        {
            dataField: 'invoicedPackagePrice',
            text: 'Price',
            sort: true,
            width: 120,
            show: true,
            inputType: 'number',
            hideColFilter: false,
            cellRenderer: (rowData, col) => rowData.price !== 0 ? currencyFormat(rowData.price) : '$0.00',
            showColumn: true
        },
        {
            dataField: 'totalSpend',
            text: 'Total Spend',
            sort: true,
            width: 140,
            show: true,
            inputType: 'number',
            hideColFilter: false,
            cellRenderer: (rowData, col) => rowData.totalSpend !== 0 ? currencyFormat(rowData.totalSpend) : '$0.00',
            showColumn: true
        },
        {
            dataField: 'price340B',
            text: '340B Price/Pack',
            sort: true,
            width: 160,
            show: true,
            inputType: 'number',
            hideColFilter: false,
            cellRenderer: (rowData, col) => rowData.price340B !== null ? currencyFormat(rowData.price340B) : '$0.00',
            showColumn: true
        },
        {
            dataField: 'price340BTotalSpend',
            text: '340B Total Spend',
            sort: false,
            width: 160,
            show: true,
            inputType: 'number',
            hideColFilter: true,
            cellRenderer: (rowData, col) => rowData.price340BTotalSpend !== null ? currencyFormat(rowData.price340BTotalSpend) : '$0.00',
            showColumn: true
        },
        {
            dataField: 'priceGPO',
            text: 'GPO Price/Pack',
            sort: true,
            width: 160,
            show: true,
            inputType: 'number',
            hideColFilter: false,
            cellRenderer: (rowData, col) => rowData.priceGPO !== null ? currencyFormat(rowData.priceGPO) : '$0.00',
            showColumn: true
        },
        {
            dataField: 'priceGPOTotalSpend',
            text: 'GPO Total Spend',
            sort: false,
            width: 160,
            show: true,
            inputType: 'number',
            hideColFilter: true,
            cellRenderer: (rowData, col) => rowData.priceGPOTotalSpend !== null ? currencyFormat(rowData.priceGPOTotalSpend) : '$0.00',
            showColumn: true
        },
        {
            dataField: 'priceWAC',
            text: 'WAC Price/Pack',
            sort: true,
            width: 160,
            show: true,
            inputType: 'number',
            hideColFilter: false,
            cellRenderer: (rowData, col) => rowData.priceWAC !== null ? currencyFormat(rowData.priceWAC) : '$0.00',
            showColumn: true
        },
        {
            dataField: 'priceWACTotalSpend',
            text: 'WAC Total Spend',
            sort: false,
            width: 160,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (rowData, col) => rowData.priceWACTotalSpend !== null ? currencyFormat(rowData.priceWACTotalSpend) : '$0.00',
            showColumn: true
        },
        {
            dataField: 'saving340B',
            text: '340B Savings/Pack',
            sort: true,
            width: 180,
            show: true,
            inputType: 'number',
            hideColFilter: false,
            cellRenderer: (rowData, col) => rowData.saving340B !== null ? currencyFormat(rowData.saving340B) : '$0.00',
            showColumn: true
        },
        {
            dataField: 'price340BTotalSavings',
            text: '340B Total Savings',
            sort: false,
            width: 180,
            show: true,
            inputType: 'number',
            hideColFilter: true,
            cellRenderer: (rowData, col) => rowData.price340BTotalSavings !== null ? currencyFormat(rowData.price340BTotalSavings) : '$0.00',
            showColumn: true
        },
        {
            dataField: 'wacImpact',
            text: 'WAC Impact',
            sort: true,
            width: 160,
            show: true,
            inputType: 'number',
            hideColFilter: false,
            cellRenderer: (rowData, col) => rowData.wacImpact !== null ? currencyFormat(rowData.wacImpact) : '$0.00',
            showColumn: true
        },

    ]
    let wacimpactreport = [
        {
            dataField: 'options',
            text: 'Options',
            sort: false,
            width: 80,
            show: true,
            hidecolFilter: true,
            action: true
        },
        {
            dataField: 'accountType',
            text: 'Account Type',
            sort: false,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.accountType),
            showColumn: true
        },
        {
            dataField: 'wholesaler',
            text: 'Wholesaler',
            sort: false,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.wholesaler),
            showColumn: true
        },
        {
            dataField: 'poNumber',
            text: 'PO #',
            sort: true,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.poNumber),
            showColumn: true
        },
        {
            dataField: 'sourcePoNumber',
            text: 'Source PO #',
            sort: true,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.sourcePoNumber),
            showColumn: true
        },
        {
            dataField: 'poType',
            text: 'PO Type',
            sort: true,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.poType),
            showColumn: true
        },
        {
            dataField: 'purchaseDate',
            text: 'Purchase Date',
            sort: false,
            width: 160,
            show: true,
            inputType: 'date',
            hideColFilter: true,
            cellRenderer: (rowData, col) => dateFormate(rowData.purchaseDate),
            showColumn: true
        },
        {
            dataField: 'accountNumber',
            text: '	Account #',
            sort: false,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.accountNumber),
            showColumn: true
        },
        {
            dataField: 'poItemNumber',
            text: 'PO Item #',
            sort: true,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.poItemNumber),
            showColumn: true
        },
        {
            dataField: 'ndc',
            text: 'NDC',
            sort: true,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.ndc),
            showColumn: true
        },
        {
            dataField: 'drugName',
            text: 'Drug Name',
            sort: true,
            width: 280,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.drugName),
            showColumn: true
        },
        {
            dataField: 'invoiceNumber',
            text: 'Invoice #',
            sort: true,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.invoiceNumber),
            showColumn: true
        },
        {
            dataField: 'invoicedDate',
            text: 'Invoiced Date',
            sort: true,
            width: 120,
            show: true,
            inputType: 'date',
            hideColFilter: false,
            cellRenderer: (rowData, col) => dateFormate(rowData.invoicedDate),
            showColumn: true
        },
        {
            dataField: 'packages',
            text: 'Packages',
            sort: true,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.packages),
            showColumn: true
        },
        {
            dataField: 'price',
            text: 'Price',
            sort: true,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => rowData.price !== 0 ? currencyFormat(rowData.price) : '$0.00',
            showColumn: true
        },
        {
            dataField: 'totalSpend',
            text: 'Total Spend',
            sort: true,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => rowData.totalSpend !== 0 ? currencyFormat(rowData.totalSpend) : '$0.00',
            showColumn: true
        },
        {
            dataField: 'price340BPerPack',
            text: '340B Price/Pack',
            sort: true,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => rowData.price340BPerPack !== null ? currencyFormat(rowData.price340BPerPack) : '$0.00',
            showColumn: true
        },
        {
            dataField: 'totalSpend340B',
            text: '340B Total Spend',
            sort: true,
            width: 160,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => rowData.totalSpend340B !== null ? currencyFormat(rowData.totalSpend340B) : '$0.00',
            showColumn: true
        },
        {
            dataField: 'priceGPOPerPack',
            text: 'GPO Price/Pack',
            sort: true,
            width: 160,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => rowData.priceGPOPerPack !== null ? currencyFormat(rowData.priceGPOPerPack) : '$0.00',
            showColumn: true
        },
        {
            dataField: 'totalSpendGPO',
            text: 'GPO Total Spend',
            sort: true,
            width: 160,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => rowData.totalSpendGPO !== null ? currencyFormat(rowData.totalSpendGPO) : '$0.00',
            showColumn: true
        },
        {
            dataField: 'priceWACPerPack',
            text: 'WAC Price/Pack',
            sort: true,
            width: 160,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => rowData.priceWACPerPack !== null ? currencyFormat(rowData.priceWACPerPack) : '$0.00',
            showColumn: true
        },
        {
            dataField: 'totalSpendWAC',
            text: 'WAC Total Spend',
            sort: true,
            width: 160,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => rowData.totalSpendWAC !== null ? currencyFormat(rowData.totalSpendWAC) : '$0.00',
            showColumn: true
        },
        {
            dataField: 'savings340BPerPack',
            text: '340B Savings/Pack',
            sort: true,
            width: 180,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => rowData.savings340BPerPack !== null ? currencyFormat(rowData.savings340BPerPack) : '$0.00',
            showColumn: true
        },
        {
            dataField: 'totalSavings340B',
            text: '340B Total Savings',
            sort: true,
            width: 160,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => rowData.totalSavings340B !== null ? currencyFormat(rowData.totalSavings340B) : '$0.00',
            showColumn: true
        },
        {
            dataField: 'wacImpact',
            text: 'WAC Impact',
            sort: true,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => rowData.wacImpact !== null ? currencyFormat(rowData.wacImpact) : '$0.00',
            showColumn: true
        },

    ]

    const handleSearchColumnFilters = (colFilter) => {
      debugger;
      const filterObj = cloneDeep(search);
      if (onSearchColumnFilters) {
        onSearchColumnFilters(colFilter);
        filterObj.filters = [...filterObj.filters, ...colFilter];
        setColumnFilters(colFilter);
      }
    };

    
    const handleDrugspentExportDetails = async () => {
        debugger;
        const filterObj = cloneDeep(search);

        if (columnFilters && columnFilters.length > 0) {
          filterObj.filters = [...filterObj.filters, ...columnFilters];
        }
    
        const { access_token } =
          JSON.parse(localStorage.getItem('pharmaforce')) || {};
    
          var additionalCriteria = {};
          additionalCriteria.IsSelectedColumn = false;
          additionalCriteria.OrgId = orgId.organizationID;
           // additionalCriteria.ContractId = 0;
        // additionalCriteria.POId = 0;
        // additionalCriteria.OpaId = 0;
        // additionalCriteria.CEId = 0;
        // additionalCriteria.ManufactureId = 0;
    
        var payload = {};
        payload.tenantID = orgId.tenantID
        
         if(FullRowData && Object.keys(FullRowData)?.length > 0){
          filterObj.Accountype =  FullRowData.accountType
          filterObj.AccumulationIDs = filterObj.AccumulationIDs.filter(x=>x == FullRowData.accumulatorId)
          filterObj.AccuntNumer= FullRowData.accuntNumer
          filterObj.status = FullRowData.poStatus
         }
        payload.gridCode = "reportDrugspendDetails";
        payload.fileTypeCode = "csv";
        payload.criteria = JSON.stringify(filterObj);
        payload.additionalCriteria = JSON.stringify(additionalCriteria);
        const { data } = await API.post(`export/queue`, payload, {
          hasExport: true,
        });
      //  const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${orgId.tenantID}/Reports/ExportManufacturerAlls?access_token=${access_token}`;
      //  onExport(action, initialFilters);
      };
 const handleUtilizationExportDetails = async () => {
    debugger;
    const filterObj = cloneDeep(search);
    
    if (columnFilters && columnFilters.length > 0) {
      filterObj.filters = [...filterObj.filters, ...columnFilters];
    }

    const { access_token } =
      JSON.parse(localStorage.getItem('pharmaforce')) || {};

      var additionalCriteria = {};
      additionalCriteria.IsSelectedColumn = false;
      additionalCriteria.OrgId = orgId.organizationID;
// additionalCriteria.ContractId = 0;
    // additionalCriteria.POId = 0;
    // additionalCriteria.OpaId = 0;
    // additionalCriteria.CEId = 0;
    // additionalCriteria.ManufactureId = 0;
    var payload = {};
    payload.tenantID = orgId.tenantID
    payload.gridCode = "reportUtilizationDetils";
       if(FullRowData && Object.keys(FullRowData)?.length > 0){
          filterObj.Accountype =  FullRowData.accountType
          filterObj.AccumulationIDs = search.AccumulationIDs;
         }
    // payload.AccumulationIDs = search.AccumulationIDs;
    payload.fileTypeCode = "csv";
    payload.criteria = JSON.stringify(filterObj);
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { data } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });
  //  const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${orgId.tenantID}/Reports/ExportManufacturerAlls?access_token=${access_token}`;
  //  onExport(action, initialFilters);
  };
    const handleFilterCancel = () => {
        setColumnFilters([]);
        refetch();
    };
    const handleSort = (filter, hasColFilter) => {
        debugger;
        setState({
            filters: filter,
        });
        if (hasColFilter) {
            onPageChange(filter, true,FullRowData);
        } else {
            onPageChange(filter, false,FullRowData);
        }
    };
    const onHandlePageChange = (filter, hasColFilter, colChangedFilter) =>{
        debugger
        if(hasColFilter){
            const colFilterOn = { ...filter, filters: colChangedFilter };
            onPageChange(colFilterOn, true);
        }else{
            onPageChange(filter);
        }

    };
    const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
        debugger;
        if (hasColFilter) {
            setState({
                filters: filter,
            });
            let colFilterOn = { ...filter, filters: colChangedFilter };
            return onPageChange(colFilterOn, true);
        }
        setState({
            filters: filter,
        });
        onPageChange(filter);
    };
    const { filters: colFilter, backUpData } = state;

    if (reportType == "Drupspendbyaccount") {
        return (

            <div
                className='table-card scroll-table position-relative border-0 rounded pt-0'
                fixed-height={backUpData.length > 0 ? 'fixed-height' : 'default'}
            >
                <ReactStrapTable
                    id='reportdetails-table'
                    keytab={key}
                    data={backUpData}
                    columns={drugspentcoloums}
                    hasPagination
                    fixedColumn
                    pageSize={search.pageSize}
                    filters={filters}
                    currentPage={search.currentPage}
                    collapseSider={collapseSider}
                toggleSider={toggleSider}
                onExport={handleDrugspentExportDetails}
                showtoggle={true}
                    totalRecords={totalItem}
                         onPageChange={onHandlePageChange}
                onPageSizeChange={onPageSizeChange}
                    handleSort={handleSort}
                    onSearchColumnFilters={handleSearchColumnFilters}
                    onFilterCancel={handleFilterCancel}
                    resetFilterFlag={resetFilterFlag}
                SetResetFilterFlag={SetResetFilterFlag}
                     />
            </div>

        )
    }
    else if(reportType=="Wacimpact"){
        return (

            <div
                className='table-card scroll-table position-relative border-0 rounded pt-0'
                fixed-height={backUpData.length > 0 ? 'fixed-height' : 'default'}
            >
                <ReactStrapTable
                    id='reportdetails-table'
                    keytab={key}
                    data={pharmaOrders}
                    columns={wacimpactreport}
                    fixedColumn
                    // hasPagination
                    filters={filters}
                    pageSize={search.pageSize}
                    currentPage={search.currentPage}
                    collapseSider={collapseSider}
                toggleSider={toggleSider}
                onExport={handleDrugspentExportDetails}
                onPageChange={onHandlePageChange}
                onPageSizeChange={onPageSizeChange}
                showtoggle={true}
                    totalRecords={totalItem}
                    handleSort={handleSort}
                    onSearchColumnFilters={handleSearchColumnFilters}
                    onFilterCancel={handleFilterCancel} 
                    resetFilterFlag={resetFilterFlag}
                SetResetFilterFlag={SetResetFilterFlag}
                    />
            </div>

        )
    }
    else {
        return (

            <div
                className='table-card scroll-table position-relative border-0 rounded pt-0'
                fixed-height={backUpData.length > 0 ? 'fixed-height' : 'default'}
            >
                <ReactStrapTable
                    id='reportdetails-table'
                    keytab={key}
                    data={backUpData}
                    columns={utilizationcoloums}
                    hasPagination
                    fixedColumn
                    pageSize={search.pageSize}
                    currentPage={search.currentPage}
                    totalRecords={totalItem}
                    filters={filters}
                    handleSort={handleSort}
                    onPageChange={onHandlePageChange}
                    onPageSizeChange={onPageSizeChange}
                    onExport={handleUtilizationExportDetails}
                    onSearchColumnFilters={handleSearchColumnFilters}
                    onFilterCancel={handleFilterCancel}
                    collapseSider={collapseSider}
                toggleSider={toggleSider}
                    showtoggle={true}
                    resetFilterFlag={resetFilterFlag}
                SetResetFilterFlag={SetResetFilterFlag}
                />
            </div>

        )
    }

}
export default SbDetailsTable;